<template>
    <section class="card-section section-30" id="card-section">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <div class="reg-btn-row">
                        <router-link to="/investor-registration" class="business-btn enhanced-btn">
                            <div class="reg-icon">💰</div>
                            <div class="reg-content">
                                <div class="reg-title">Start A Business Today</div>
                                <div class="smallimp">💰 Invest & Grow Your Wealth</div>
                            </div>

                        </router-link>
                        <router-link to="/list-franchise" class="business-btn enhanced-btn">
                            <div class="reg-icon">🏢</div>
                            <div class="reg-content">
                                <div class="reg-title">Expand Your Franchise Network</div>
                                <div class="smallimp">🌟 Partner with Success</div>
                            </div>

                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup></script>
<style scoped>

</style>
<style scoped>
.card-section.section-30 {
  margin-top: -40px;
  z-index: 1;
  position: relative;
}

.reg-btn-row {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 24px;
  flex-wrap: wrap;
}
.business-btn.enhanced-btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  min-width: 300px;
  max-width: 480px;
  background: var(--primary-blue);
  color: #fff;
  font-size: 1.8rem;
  font-weight: 800;
  border-radius: 18px;
  padding: 28px 32px;
  text-decoration: none;
  transition: background 0.18s, box-shadow 0.18s, transform 0.18s;
  box-shadow: 0 4px 16px rgba(23, 74, 139, 0.10);
  border: none;
  letter-spacing: 0.01em;
  position: relative;
  overflow: hidden;
  gap: 20px;
  top: -30px;
}
.business-btn.enhanced-btn:hover {
  background: #0d3a6b;
  transform: scale(1.035);
  box-shadow: 0 8px 32px rgba(23, 74, 139, 0.18);
}
.reg-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: var(--primary-blue);
  border-radius: 50%;
  width: 54px;
  height: 54px;
  font-size: 2.2rem;
  margin-right: 18px;
  box-shadow: 0 2px 8px rgba(23, 74, 139, 0.08);
}
.reg-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.reg-title {
  font-size: 2.1rem;
  font-weight: 900;
  letter-spacing: 0.01em;
  margin-bottom: 2px;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.smallimp {
  color: #fff;
  font-weight: 700;
  font-size: 1.15rem;
  margin-left: 0;
  opacity: 0.95;
  letter-spacing: 0.01em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.business-btn.enhanced-btn:hover .reg-title {
  transform: scale(1.02);
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.business-btn.enhanced-btn:hover .smallimp {
  opacity: 1;
  transform: translateY(-1px);
}
.arrow-box {
  margin-left: auto;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  width: 38px;
  min-width: 38px;
  box-shadow: 0 2px 8px rgba(23, 74, 139, 0.08);
  transition: transform 0.3s ease;
}
.arrow-box i {
  color: var(--primary-blue);
  font-size: 18px;
  font-weight: 600;
  transition: all 0.3s ease;
}
.business-btn.enhanced-btn:hover .arrow-box {
  transform: translateX(6px);
  box-shadow: 0 4px 12px rgba(23, 74, 139, 0.15);
}
.business-btn.enhanced-btn:hover .arrow-box i {
  color: #0d3a6b;
}
@media (max-width: 900px) {
  .business-btn.enhanced-btn {
    font-size: 1.4rem;
    padding: 20px 16px;
    min-width: 280px;
    gap: 16px;
  }
  .reg-title {
    font-size: 1.4rem;
  }
  .reg-icon {
    width: 40px;
    height: 40px;
    font-size: 1.4rem;
    margin-right: 12px;
  }

  .reg-btn-row {
    gap: 16px;
    justify-content: center;
    align-items: stretch;
  }
}

@media (max-width: 768px) {
  .card-section.section-30 {
    margin-top: 32px !important;
    box-shadow: 0 4px 24px rgba(44,62,80,0.10);
    border-radius: 18px;
    background: #fff;
    z-index: 20;
    position: relative;
    padding: 12px 0;
    border: 2px solid red !important;
  }
  .reg-btn-row {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .business-btn.enhanced-btn {
    min-width: 90vw;
    max-width: 98vw;
    width: 100%;
    font-size: 1.1rem;
    padding: 18px 12px;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(23, 74, 139, 0.13);
    margin: 0 auto;
    background: #fff;
    color: var(--primary-blue);
    border: 1px solid #e0e7ef;
    position: relative;
  }
  .business-btn.enhanced-btn .reg-title,
  .business-btn.enhanced-btn .smallimp {
    color: var(--primary-blue);
    text-shadow: none;
  }
  .business-btn.enhanced-btn .reg-icon {
    background: var(--primary-blue);
    color: #fff;
    box-shadow: 0 2px 8px rgba(23, 74, 139, 0.10);
  }
}
</style>








<!-- <style scoped>
.card-section.section-30 {
  margin-top: -20px;
  z-index: 10;
  position: relative;
}

.reg-btn-row {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 24px;
  flex-wrap: wrap;
}
.business-btn.enhanced-btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  min-width: 300px;
  max-width: 480px;
  background: var(--primary-blue);
  color: #fff;
  font-size: 1.8rem;
  font-weight: 800;
  border-radius: 18px;
  padding: 28px 32px;
  text-decoration: none;
  transition: background 0.18s, box-shadow 0.18s, transform 0.18s;
  box-shadow: 0 4px 16px rgba(23, 74, 139, 0.10);
  border: none;
  letter-spacing: 0.01em;
  position: relative;
  overflow: hidden;
  gap: 20px;
}
.business-btn.enhanced-btn:hover {
  background: #0d3a6b;
  transform: scale(1.035);
  box-shadow: 0 8px 32px rgba(23, 74, 139, 0.18);
}
.reg-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: var(--primary-blue);
  border-radius: 50%;
  width: 54px;
  height: 54px;
  font-size: 2.2rem;
  margin-right: 18px;
  box-shadow: 0 2px 8px rgba(23, 74, 139, 0.08);
}
.reg-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.reg-title {
  font-size: 2.1rem;
  font-weight: 900;
  letter-spacing: 0.01em;
  margin-bottom: 2px;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.smallimp {
  color: #fff;
  font-weight: 700;
  font-size: 1.15rem;
  margin-left: 0;
  opacity: 0.95;
  letter-spacing: 0.01em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.business-btn.enhanced-btn:hover .reg-title {
  transform: scale(1.02);
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.business-btn.enhanced-btn:hover .smallimp {
  opacity: 1;
  transform: translateY(-1px);
}
.arrow-box {
  margin-left: auto;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  width: 38px;
  min-width: 38px;
  box-shadow: 0 2px 8px rgba(23, 74, 139, 0.08);
  transition: transform 0.3s ease;
}
.arrow-box i {
  color: var(--primary-blue);
  font-size: 18px;
  font-weight: 600;
  transition: all 0.3s ease;
}
.business-btn.enhanced-btn:hover .arrow-box {
  transform: translateX(6px);
  box-shadow: 0 4px 12px rgba(23, 74, 139, 0.15);
}
.business-btn.enhanced-btn:hover .arrow-box i {
  color: #0d3a6b;
}
@media (max-width: 900px) {
  .business-btn.enhanced-btn {
    font-size: 1.4rem;
    padding: 20px 16px;
    min-width: 280px;
    gap: 16px;
  }
  .reg-title {
    font-size: 1.4rem;
  }
  .reg-icon {
    width: 40px;
    height: 40px;
    font-size: 1.4rem;
    margin-right: 12px;
  }

  .reg-btn-row {
    gap: 16px;
    justify-content: center;
    align-items: stretch;
  }
}

@media (max-width: 768px) {
  .reg-btn-row {
    flex-direction: column;
    gap: 16px;
  }
  .business-btn.enhanced-btn {
    min-width: 100%;
    max-width: 100%;
    font-size: 1.2rem;
    padding: 18px 16px;
  }
  .reg-title {
    font-size: 1.2rem;
  }
  .reg-icon {
    width: 36px;
    height: 36px;
    font-size: 1.2rem;
  }
  .arrow-box {
    height: 32px;
    width: 32px;
    min-width: 32px;
  }
  .arrow-box i {
    font-size: 14px;
  }
}
</style> -->